export const buildSelectorPreviewTheme = (colors, baseTheme) => {
  const normalColors = colors?.types?.normal?.colors || {}
  const hoverColors = colors?.types?.hover?.colors || {}
  const selectedColors = colors?.types?.selected?.colors || {}

  return {
    ...baseTheme,
    splitButton: {
      ...baseTheme.splitButton,
      backgroundColor: normalColors.splitButtonBackgroundColor?.color || baseTheme.splitButton.backgroundColor,
      borderColor: normalColors.splitButtonBorderColor?.color || baseTheme.splitButton.borderColor,
      color: normalColors.splitButtonColor?.color || baseTheme.splitButton.color,
      iconColor: normalColors.splitButtonIconColor?.color || baseTheme.splitButton.iconColor,
      hover: {
        backgroundColor:
          hoverColors.splitButtonHoverBackgroundColor?.color || baseTheme.splitButton.hover.backgroundColor,
        borderColor: hoverColors.splitButtonHoverBorderColor?.color || baseTheme.splitButton.hover.borderColor,
        color: hoverColors.splitButtonHoverColor?.color || baseTheme.splitButton.hover.color,
        iconColor: hoverColors.splitButtonHoverIconColor?.color || baseTheme.splitButton.hover.iconColor,
      },
      selected: {
        backgroundColor:
          selectedColors.splitButtonSelectedBackgroundColor?.color || baseTheme.splitButton.selected.backgroundColor,
        borderColor: selectedColors.splitButtonSelectedBorderColor?.color || baseTheme.splitButton.selected.borderColor,
        color: selectedColors.splitButtonSelectedColor?.color || baseTheme.splitButton.selected.color,
        iconColor: selectedColors.splitButtonSelectedIconColor?.color || baseTheme.splitButton.selected.iconColor,
      },
    },
    variantButton: {
      ...baseTheme.variantButton,
      backgroundColor: normalColors.variantButtonBackgroundColor?.color || baseTheme.variantButton.backgroundColor,
      borderColor: normalColors.variantButtonBorderColor?.color || baseTheme.variantButton.borderColor,
      color: normalColors.variantButtonColor?.color || baseTheme.variantButton.color,
      hover: {
        backgroundColor:
          hoverColors.variantButtonHoverBackgroundColor?.color || baseTheme.variantButton.hover.backgroundColor,
        borderColor: hoverColors.variantButtonHoverBorderColor?.color || baseTheme.variantButton.hover.borderColor,
        color: hoverColors.variantButtonHoverColor?.color || baseTheme.variantButton.hover.color,
      },
      selected: {
        backgroundColor:
          selectedColors.variantButtonSelectedBackgroundColor?.color ||
          baseTheme.variantButton.selected.backgroundColor,
        borderColor:
          selectedColors.variantButtonSelectedBorderColor?.color || baseTheme.variantButton.selected.borderColor,
        color: selectedColors.variantButtonSelectedColor?.color || baseTheme.variantButton.selected.color,
      },
    },
  }
}
